module.exports = __webpack_public_path__ + "static/img/rank_123.bb455c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_123.png
// module id = hgT4
// module chunks = 0